<template>
	<div class="section">
		<div class="container">
			<div class="title is-1">Update your password</div>
			<div class="columns">
				<div class="column is-one-third">
					<b-input type="email" v-model="Email" placeholder="Email address"></b-input>
					<br />
					<b-input type="password" v-model="NewPassword" placeholder="New password"></b-input>
					<br />
					<b-input type="password" v-model="ConfirmPassword" placeholder="Confirm password"></b-input>
					<br />
					<b-button class="is-primary" v-bind:class="{'is-loading': loading == true}" @click="resetPassword">Reset password</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'resetpassword',
		props: {
			code: String
		},
		data() {
			return {
				Email: '',
				NewPassword: '',
				ConfirmPassword: '',
				loading: false
			}
		},
		methods: {
			async resetPassword() {
				this.loading = true;
				if (this.NewPassword.length <= 6) {
					this.$buefy.toast.open({
						message: "Please make sure the length of your passsword is more than 6 characters.",
						type: "is-danger",
					});
					this.loading = false;
				}
				else if ((this.Email && this.NewPassword && this.ConfirmPassword) && (this.NewPassword == this.ConfirmPassword)) {
					await this.$http.post("api/authentication/resetPassword", { Code: this.code, Email: this.Email, NewPassword: this.NewPassword })
						.then(resp => {
							if (resp.data == "No User Found.") {
								this.openBadNotification("You must enter a valid User email.");
							} else if (resp.data == "Reset password token invalid. Please try to send yourself a new link.") {
								this.openBadNotification("An unhandled error occurred. Please send yourself a new link.");
							} else if (resp.data == "Invalid Username") {
								this.openBadNotification("Please enter your email in the correct format.");
							} else if (resp.data == "PasswordTooShort") {
								this.openBadNotification("Please enter a large enough password. Must be over 6 characters.");
							} else if (resp.data == "InvalidToken") {
								this.openBadNotification("Your token is invalid. Please try to send yourself a new link.");
							} else if (resp.data == "Success") {
								this.$buefy.toast.open({
									duration: 4000,
									message: "Your password was reset successfully",
									type: 'is-success',
								});
								this.$router.push("/login");
							} else {
								this.openBadNotification("An error occurred. Please try again later.");
							}
							this.loading = false;
						}).catch(err => {
							this.loading = false;
							this.openBadNotification("An error occurred. Please try again later.");
						})
				} else {
					this.loading = false;
					if (!this.Email)
						this.openBadNotification("Please enter your email");
					else
						this.openBadNotification("Please check your passwords, they do not match.")
				}
			},
			openBadNotification(message) {
				this.$buefy.toast.open({
					duration: 4000,
					message: message,
					type: 'is-danger',
				})
			}
		}
	}
</script>
